import REQUEST from "@/assets/js/request"
const urlData='';
// const urlData ="http://192.168.22.227:9100"
// const urlData ="https://xzw.xzyunchuang.com/prod-api"
// 县域新闻
export const countyNews = (DATA) => {
  return REQUEST({
    url: urlData+'/article/countyNews',
    data: DATA,
    method: 'get'
  })
}
// 文章列表
export const articleList = (DATA) => {
  return REQUEST({
    url: urlData+'/article/articleList',
    params: DATA,
    method: 'get'
  })
}
// 人物报道集
export const leaderReports = (DATA) => {
  return REQUEST({
    url: urlData+'/index/leaderReports',
    params: DATA,
    method: 'get'
  })
}
// 新闻详情http://192.168.22.227:9100/article/detail
export const articleDetail = (DATA) => {
  return REQUEST({
    url: urlData+'/article/detail',
    params: DATA,
    method: 'get'
  })
}
// 最新资讯和徐州发布
export const otherNews = (DATA) => {
  return REQUEST({
    url: urlData+'/article/otherNews',
    params: DATA,
    method: 'get'
  })
}
// 前一条咨询，后一条咨询
export const relateNews = (DATA) => {
  return REQUEST({
    url: urlData+'/article/relateNews',
    params: DATA,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/news.js